import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const DepositView = () => {
  const { id } = useParams();
  const [deposit, setDeposit] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Http.get(`/accounts/deposits/${id}`)
      .then((res) => {
        setDeposit(res.data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Deposit Details</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Deposit Information</h6>
            
            {loading ? (
              <ProgressSpinner />
            ) : (
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <tbody>
                    <tr>
                      <th width="200">Bank</th>
                      <td>{deposit.bank?.name}</td>
                    </tr>
                    <tr>
                      <th>Account Number</th>
                      <td>{deposit.bank?.account_number}</td>
                    </tr>
                    <tr>
                      <th>Amount</th>
                      <td>{deposit.amount}</td>
                    </tr>
                    <tr>
                      <th>Deposit Date</th>
                      <td>{new Date(deposit.date).toLocaleDateString()}</td>
                    </tr>
                    <tr>
                      <th>Counter No</th>
                      <td>{deposit.counter_no}</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td>{deposit.description}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <td>
                        {deposit.status === "active" || deposit.status === "Active" ? (
                          <span className="badge badge-success">Active</span>
                        ) : (
                          <span className="badge badge-danger">Inactive</span>
                        )}
                      </td>
                    </tr>
                    {/* <tr>
                      <th>Created At</th>
                      <td>{new Date(deposit.created_at).toLocaleString()}</td>
                    </tr>
                    <tr>
                      <th>Updated At</th>
                      <td>{new Date(deposit.updated_at).toLocaleString()}</td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositView;